import React from "react";
import { TimePicker as AntdTimePicker, TimeRangePickerProps } from "antd";
import LocaleProvider from "../../../i18n/LocaleProvider";

const { RangePicker: AntdRangePicker } = AntdTimePicker;

type IRangeProps = {
    confirm?: boolean;
} & TimeRangePickerProps;

class TimeRangePicker extends React.Component<IRangeProps> {
    private panelRef = React.createRef<HTMLDivElement>();

    handlePanelClick = (e: React.MouseEvent<HTMLDivElement>) => {
        const { confirm } = this.props;
        if (confirm) return;

        const target = e.target as HTMLElement;
        // Check if the click occurred on a time item in the list
        if (target.closest(".ant-picker-time-panel-cell")) {
            // Short delay to let Antd's internal panel update active values first
            setTimeout(() => {
                const okBtn = this.panelRef.current?.querySelector(
                    ".ant-picker-ok button"
                ) as HTMLButtonElement | null;
                okBtn?.click();
            }, 0);
        }
    };

    render() {
        const { confirm, ...restProps } = this.props;

        return (
            <AntdRangePicker
                locale={LocaleProvider.getPicker()}
                {...restProps}
                panelRender={panel => (
                    <div
                        ref={this.panelRef}
                        className={confirm ? "" : "ant-picker-no-ok"}
                        onClick={this.handlePanelClick}
                    >
                        {panel}
                    </div>
                )}
            />
        );
    }
}

export default TimeRangePicker;